import { Link } from 'gatsby';
import styled from 'styled-components';
import { media } from './media';

export const Section = styled.section`
  height: 528px;
  position: relative;
  overflow: hidden;
  background: var(--grey-2);

  @media ${media.mdUp} {
    height: 670px;
  }
  @media ${media.lgUp} {
    height: 800px;
  }

  .bg--photo {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
    background-position: center !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    overflow: hidden;
    z-index: 1;

    &.left {
      display: none;
      left: initial;

      @media ${media.mdUp} {
        display: block;
      }
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  background-color: ${(props) => props.$bgColor || 'transparent'};
  color: ${(props) => props.$textColor || 'inherit'};

  &.column {
    flex-direction: column;
  }

  &.center {
    align-items: center;
  }
`;

export const WhiteSquare = styled.div`
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 1rem;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 32px 28px 24px 28px;
  max-width: 350px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: var(--color-bg);

  &.left {

    @media ${media.mdUp} {
      left: 60px;
      right: unset;
    }
  }

  &.right {

    @media ${media.mdUp} {
      right: 60px;
      left: unset;
    }
  }

  @media ${media.mdUp} {
    position: absolute;
    padding: 40px 36px 28px 36px;
    max-width: 400px;
    bottom: 60px;
  }
`;

export const SquareTitle = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 18px;
  line-height: 1.3;
  color: var(--color-bg);
`;

export const SquareCTA = styled(Link)`
  font-size: 1rem;
  color: var(--color-bg);
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s;
  color: var(--color-bg);

  &:hover {
    color: var(--color-bg);
  }
`;

export const BgOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  z-index: 2;
`;

export const Content = styled.div`
  position: relative;
  z-index: 3;
  width: 100%;
  height: 100%;
  max-width: ${(props) => props.$maxWidth || '1200px'};
  padding: ${(props) => props.$padding || '0 0'};
  margin: 0 auto;

  &.algorithm-page-graphic-right {
    padding-top: 2rem;
    color: var(--color-text);
    background-color: var(--color-bg);

    align-content: center;
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: center;

    h2 {
      font-weight: bold;

      text-align: left;
      padding-left: 0.5rem;

      @media ${media.smUp} {
        padding-left: 3.5rem;
        padding-right: 1rem;
      }

      @media ${media.mdUp} {
        padding-left: 4rem;
        max-width: 420px;
      }
    }

    p {
      font-size: 1.5rem;
      max-width: 370px;
      text-align: left;
      padding-left: 0.5rem;

      @media ${media.smUp} {
        padding-left: 3.5rem;
        padding-right: 1rem;
        max-width: 470px;

      }

      @media ${media.mdUp} {
        padding-left: 4rem;
        max-width: 370px;
      }
    }

    @media ${media.mdUp} {
      width: 50%;
      transform: translateX(50%);
    }
  }

  &.algorithm-does-it-all {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    height: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    color: var(--color-bg);

    // TODO adjust for at scale on new line
    h2 {
      font-size: 2rem;
      line-height: 3rem;

      @media ${media.mdUp} {
        font-size: 2.75rem;
      }

      @media ${media.lgUp} {
        text-align: left;
        width: 43%;
        font-size: 3rem;
        font-weight: bold;
        padding-top: 1rem;
      }
    }

    p {
      font-size: 1.25rem;

      @media ${media.lgUp} {
        font-size: 1.5rem;
        text-align: right;
        margin-top: 2rem;
      }
    }
  }

  &.algorithm-analytics {
    p {
      &.last {
        margin-bottom: 15rem !important;

        @media ${media.mdUp} {
          margin-bottom: 15rem !important;
        }

        @media ${media.lgUp} {
          margin-bottom: 3rem !important;
        }
      }
    }
  }

  &.algorithm-analytics {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: left;

    span.percent {
      font-size: 2rem;
      font-weight: 600;

      @media ${media.mdUp} {
        font-size: 3.5rem;
      }
    }

    h2 {
      font-size: 2rem;
      line-height: 3rem;
      color: var(--color-bg);
      margin-bottom: 1rem;
      font-weight: bold;

      @media ${media.mdUp} {
        font-size: 2.75rem;
      }

      @media ${media.lgUp} {
        text-align: left;
        font-size: 4rem;
      }
    }

    p {
      color: var(--color-bg);
      text-align: left;
      font-size: 1.5rem !important;
      line-height: 1.2 !important;
      margin-bottom: 0.5rem !important;

      @media ${media.mdUp} {
        font-size: 2.5rem !important;
      }

      @media ${media.mdUp} {
        font-size: 1rem;
        text-align: left;
      }
    }
  }

  &.algorithm-license-contact {
    display: flex;
    flex-direction: column;
    background-color: var(--color-primary);
    justify-content: center;

    h2,
    h3 {
      color: var(--color-bg);
    }

    @media ${media.mdUp} {
      justify-content: initial;
      flex-direction: row;
    }

    .algorithm-license-contact-left {
      padding: 0 4rem;
      display: flex;
      flex-direction: column;
      justify-content: center;

      a {
        display: none;
      }

      @media ${media.mdUp} {
        width: 50%;

        a {
          display: block;
        }
      }
    }

    .algorithm-license-contact-right {
      margin-top: 1rem;
      padding: 0 4rem;
      flex-direction: column;
      justify-content: center;

      a {
          display: block;
      }

      h3 {
        font-size: 1.5rem;
        margin-bottom: 1rem;
      }

      @media ${media.mdUp} {
        display: flex;
        margin-top: 0;
        width: 50%;

        a {
          display: none;
        }
      }
    }
  }

  &.homepage-analytics {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: center;

    span.percent {
      font-size: 2rem;
      font-weight: 600;

      @media ${media.mdUp} {
        font-size: 3.5rem;
      }
    }

    h2 {
      font-size: 2rem;
      line-height: 3rem;
      color: var(--color-bg);
      margin-bottom: 1rem;
      font-weight: bold;

      @media ${media.mdUp} {
        font-size: 2.75rem;
      }

      @media ${media.lgUp} {
        text-align: left;
        font-size: 4rem;
      }
    }

    p {
      color: var(--color-bg);
      text-align: center;
      font-size: 1.5rem !important;
      line-height: 1.2 !important;
      margin-bottom: 0.5rem !important;

      @media ${media.mdUp} {
        font-size: 2.5rem !important;
      }

      /* Homepage "Road-tested over 50+ global deployments" */
      &:last-child {
        font-size: 1.75rem;

        @media ${media.mdUp} {
          font-size: 3rem;
        }
      }

      @media ${media.mdUp} {
        font-size: 1rem;
        text-align: left;
      }
    }
  }

  &.algorithm-hero .h1,
  &.homepage-hero .h1 {
    position: absolute;
    top: 40%;
    right: 40px;
    transform: translateY(-50%);
    margin: 0;
    color: var(--color-bg);
    text-align: right;

    @media ${media.mdUp} {
      top: 50%;
    }
  }

  &.homepage-zoox {
    position: relative;

    .name {
      font-size: 1.25rem;
      font-weight: 700;
    }

    .zoox-company {
      text-align: left;
      position: absolute;
      top: 2rem;
    }
  }

  &.product-page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    @media ${media.mdUp} {
      align-items: flex-end;
      text-align: left;
      padding-right: 1rem;
    }
  }

  &.product-page .h1 {
    font-weight: bold;
    color: white;
    margin: 0;

    @media ${media.mdUp} {
      width: 50%;
    }
  }

  &.product-page .h3 {
    color: white;
    font-weight: 200;
    margin-top: 2rem;

    @media ${media.mdUp} {
      width: 50%;
    }
  }

  &.homepage-zoox {
    h2 {
      font-size: 32px;

      @media ${media.smUp} {
        font-size: 36px;
      }
    }


  }

  &.homepage-zoox,
  &.homepage-algorithm,
  &.homepage-product {
    align-content: center;
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: center;

    @media ${media.mdUp} {
      text-align: left;
    }

    h2 {
      color: var(--color-bg);

      @media ${media.mdUp} {
        /* medium styles */
      }
    }

    p {
      color: var(--color-bg);
      font-size: 1.5rem;
      @media ${media.mdUp} {
        /* medium styles */
      }
    }

    a {
      margin-top: 1rem;
    }
  }

  &.our-story {
    p {
      font-size: 20px;
      line-height: 30px;
    }
  }
`;

export const StyledBlackSection = styled.section`
  background: var(--color-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 0;
`;

export const StyledWhiteSection = styled.section`
  background: var(--color-bg);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 0;
`;

export const CTAText = styled.p`
  color: var(--color-bg);
  font-size: 1.5rem;
  text-align: center;
  line-height: 1.7rem;
  margin-bottom: 0.875rem;
  padding: 0px 0.5rem;

  @media ${media.mdUp} {
    padding: initial;
    font-size: 1.75rem;
    line-height: 2rem;
    margin-bottom: 0 !important;
  }

  @media ${media.lgUp} {
    font-size: 2rem;
    line-height: 3rem;
    margin-bottom: 0 !important;
  }
`;

export const WhiteCTAText = styled.p`
  color: var(--color-primary);
  font-size: 1.5rem;
  text-align: center;
  line-height: 1.7rem;
  margin-bottom: 0.875rem;
  padding: 0px 0.5rem;

  @media ${media.mdUp} {
    padding: initial;
    font-size: 1.75rem;
    line-height: 2rem;
    margin-bottom: 0 !important;
  }

  @media ${media.lgUp} {
    font-size: 2rem;
    line-height: 3rem;
    margin-bottom: 0 !important;
  }
`;
